import {sector} from 'constants/url';
import useUpdate from 'components/hooks/useUpdate';
import {EditingOptions} from 'components/grid-dx/types';

function useUpdateSector() {
  const UpdateSector = useUpdate(sector);
  return (editingOptions: EditingOptions) => UpdateSector(editingOptions);
}

export default useUpdateSector;
